import { createFileRoute, redirect } from "@tanstack/react-router";

// URL antigua: redirección permanente a la ruta limpia.
export const Route = createFileRoute("/calculadora-rentabilidad-retail")({
  beforeLoad: () => {
    throw redirect({ to: "/herramientas/calculadora", statusCode: 301 });
  },
});
